import pagesLaborCoreAnchorDateEn from './anchor-date/default';
import pagesLaborCoreGovernmentApplicationConfirmationEn from './government-application-confirmation/default';
import pagesLaborCoreTagNameEn from './group-name/default';
import pagesLaborCoreInstanceEn from './instance/default';
import pagesLaborCoreOperationPackagesEn from './operation-packages/default';
import pagesLaborCoreSelectTargetsEn from './select-targets/default';
import pagesLaborCoreSettingsEn from './settings/default';
import pagesLaborCoreYearEndAdjustmentConfirmationEn from './year-end-adjustment-confirmation/default';

export default {
  anchorDate: pagesLaborCoreAnchorDateEn,
  governmentApplicationConfirmation:
    pagesLaborCoreGovernmentApplicationConfirmationEn,
  instance: pagesLaborCoreInstanceEn,
  operationPackages: pagesLaborCoreOperationPackagesEn,
  selectTargets: pagesLaborCoreSelectTargetsEn,
  settings: pagesLaborCoreSettingsEn,
  tagName: pagesLaborCoreTagNameEn,
  yearEndAdjustmentConfirmation: pagesLaborCoreYearEndAdjustmentConfirmationEn,
};
